import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  sortIcon: {
    height: '0.625rem',
    marginLeft: theme.spacing(0.5)
  },
  rulesTableContainer: {
    height: '100%',
    position: 'relative',
    boxShadow: theme.shadows[2],
    borderRadius: 4,
    backgroundColor: theme.vars.palette.background.elevation2
  },
  noData: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    color: theme.vars.palette.text.secondary
  },
  rulesTable: {
    height: '100%'
  },
  rulesTableHeaderCell: {
    padding: '0.5rem',
    backgroundColor: theme.vars.palette.background.elevation2
  },
  rulesTablePagination: {
    position: 'sticky',
    zIndex: 29,
    display: 'relative',
    bottom: 0,
    borderTop: `1px solid ${theme.vars.palette.border.light}`,
    borderBottom: 0, // remove weird bottom border when selecting 50 rows
    backgroundColor: theme.vars.palette.background.elevation2
  },
  tableBodyCell: {
    padding: '0 0 0 0.5rem'
  },
  tableWidget: {
    '.MuiDataGrid-container--top [role=row] ': {
      backgroundColor: theme.vars.palette.background.elevation2
    }
  }
}));

export default useStyles;
